
 export const countdownType = {
  FIXED_EXPIRATION: 'FIXED_EXPIRATION',
  INDIVIDUAL_COUNTDOWN: 'INDIVIDUAL_COUNTDOWN',
}